const reflect = promise => promise.then(data => data, () => ({}))
export default reflect
